<template>
    <div class="text_two">
        <p>Enter your provided Evaluation Product code below to get started. If you do not know your code or have lost the information, please visit our Support Page. 
        </p>
        <form v-on:submit="applyCode($event)" autocomplete="off">
            <div class="form-group pad-before-footer">
                <input class='coupon_input' v-mask="'NNNNN-NNN-NNN-NNN'" minlength="17" required type="text" v-model="couponCode">
                <input type="submit" class="btn btn-submit coupon_button" value="REDEEM THIS CODE">
            </div>
    
        </form>
    </div>
</template>
<script>
export default {
  data() {
    return {
      couponCode: ""
    };
  },
  methods: {
    applyCode(e) {
      e.preventDefault();
      if (this.couponCode.length === "xxxxx-xxx-xxx-xxx".length) {
        this.$router.push("/redeem/" + this.couponCode);
      }
    }
  }
};
</script>
<style>
.coupon_button {
  width: 350px;
}

.coupon_input {
  line-height: 14.4px;
  width: 350px;
  font-size: 25px !important;
  font-family: "Montserrat", Helvetica, Arial, san-serif;
  height: 36px;
  letter-spacing: 0.1em;
  text-align: center;
  margin: 15px auto;
}

@media only screen and (max-width: 560px) {
  .coupon_button {
    width: 100%;
    text-align: center;
    padding: 0;
  }

  .coupon_input {
    line-height: 14.4px;
    width: 100%;
    font-size: 14px !important;
    font-family: "Montserrat", Helvetica, Arial, san-serif;
    height: 36px;
    letter-spacing: 0.1em;
    text-align: center;
    margin: 15px auto;
  }
}
</style>
